import { useEffect, useState } from 'react';
import api from '../services/api';
import Input from '../components/Input';
import Table from '../components/Table';
import Button from '../components/Button';
import LookupSelect, { LookupOption } from '../components/LookupSelect';

const fetchLeaveTypeOptions = async (search: string): Promise<LookupOption[]> => {
  const res = await api.get('/lms/leave-types');
  const types = res.data.leaveTypes || [];
  const filtered = search ? types.filter((t: any) => t.name.toLowerCase().includes(search.toLowerCase())) : types;
  return filtered.map((t: any) => ({ value: t.id, label: `${t.name} (${t.code})` }));
};

export default function LeaveEligibility() {
  const [rows, setRows] = useState<any[]>([]);
  const [financialYear, setFinancialYear] = useState(String(new Date().getFullYear()));
  const [edits, setEdits] = useState<Record<string, string>>({});
  const [leaveTypeId, setLeaveTypeId] = useState('');

  const load = async () => {
    const res = await api.get('/lms/leave-eligibility', { params: { financialYear } });
    setRows(res.data.eligibility || []);
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [financialYear]);

  const save = async (employeeId: string) => {
    if (!leaveTypeId) return alert('Select the AL leave type first');
    const value = edits[employeeId];
    if (value === undefined) return;
    try {
      await api.put(`/lms/leave-eligibility/${employeeId}`, { leaveTypeId, financialYear, broughtForwardBalance: Number(value) });
      load();
    } catch (err: any) {
      alert(err.response?.data?.message || 'Failed to save');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Leave Eligibility</h1>
      <div className="bg-white rounded-lg shadow p-4 mb-4 flex gap-4 items-end">
        <Input label="Financial Year" value={financialYear} onChange={(e) => setFinancialYear(e.target.value)} />
        <div className="w-64">
          <LookupSelect label="AL Leave Type (for Brought-Forward edits)" value={leaveTypeId} onChange={setLeaveTypeId} fetchOptions={fetchLeaveTypeOptions} />
        </div>
      </div>
      <Table
        columns={[
          { key: 'code', header: 'Code' },
          { key: 'name', header: 'Name' },
          {
            key: 'broughtForwardAl', header: 'Brought-Forward AL',
            render: (r: any) => (
              <div className="flex gap-2 items-center">
                <input
                  type="number" step="0.5"
                  className="border rounded px-2 py-1 w-20 text-sm"
                  defaultValue={r.broughtForwardAl}
                  onChange={(e) => setEdits({ ...edits, [r.employeeId]: e.target.value })}
                />
                <Button variant="ghost" onClick={() => save(r.employeeId)}>Save</Button>
              </div>
            ),
          },
          { key: 'alEligible', header: 'AL Eligible (read-only)' },
          { key: 'mlEligible', header: 'ML Eligible (read-only)' },
          { key: 'ccEligible', header: 'CC Eligible (read-only)', render: (r: any) => (r.ccEligible ? 'Yes' : 'No') },
        ]}
        rows={rows}
      />
    </div>
  );
}
